import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import BlenderOutlinedIcon from "@mui/icons-material/BlenderOutlined";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import GradingOutlinedIcon from "@mui/icons-material/GradingOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

export const imageList = {
    'LeaderboardOutlined': <LeaderboardOutlinedIcon />,
    'PersonOutlineOutlined': <PersonOutlineOutlinedIcon />,
    'BlenderOutlined': <BlenderOutlinedIcon />,
    'LocalAtmOutlined': <LocalAtmOutlinedIcon />,
    'BusinessCenterOutlined': <BusinessCenterOutlinedIcon />,
    'TuneOutlined': <TuneOutlinedIcon />,
    'GradingOutlined': <GradingOutlinedIcon />,
    'StorefrontOutlined': <StorefrontOutlinedIcon />,
    'AccountCircleOutlined': <AccountCircleOutlinedIcon />,
}